import { render } from "./CTAEditor.vue?vue&type=template&id=2ba74b9c&scoped=true"
import script from "./CTAEditor.vue?vue&type=script&lang=js"
export * from "./CTAEditor.vue?vue&type=script&lang=js"

import "./CTAEditor.vue?vue&type=style&index=0&id=2ba74b9c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ba74b9c"]])

export default __exports__